/** Tones */
export const TONES = {
    friendly: 'Friendly',
    neutral: 'Neutral',
    professional: 'Professional',
    witty: 'Witty',
    excited: 'Excited',
    casual: 'Casual',
    funny: 'Funny',
    bold: 'Bold',
    dramatic: 'Dramatic',
};
